import * as React from "react";
import {IBadgable} from "../../data/entities/IBadgable";
import {observer} from "mobx-react";

import './BadgeInfoBlock.pcss';

interface Props {
  badgable:IBadgable;
  solutionCurrentPoints?:number;
}

export const BadgeInfoBlock = observer((props:Props) => {

  if(!props.badgable.badgeUsed) {
    return null;
  } else {
    return (
      <div className="badgeInfoBock">
        {props.badgable.badgeEarned ?
          <>
            <div className={"solution-badge"}>
              <img src={props.badgable.badge} alt={`Badge for ${props.badgable.name}`}/>
            </div>
            <div className={"solution-badge-info"}>
              <h2 className={'level2'}>{`${props.badgable.name} badge earned!`}</h2>
              <p>{`${props.badgable.points} total points.`}</p>
            </div>
          </>
          :
          <>
            <div className={"solution-badge"}>
              <img src={props.badgable.badgePreview} alt={`Unearned badge preview for ${props.badgable.name}`}/>
            </div>
            <div className={"solution-badge-info"}>
              <h2 className={'level2 test'}>{`Earn the ${props.badgable.name} badge`}</h2>
              {props.badgable.badgeInstructions && <p>{props.badgable.badgeInstructions}</p>}
              {undefined!==props.solutionCurrentPoints && props.solutionCurrentPoints>0 &&
                  <p className={"badge-stats"}>
                    <strong>{`${props.solutionCurrentPoints} total point${props.solutionCurrentPoints>1?'s':''} &bull; `}</strong>
                    {`${props.badgable.badgeThreshold} point${props.badgable.badgeThreshold>1?'s':''} earns the badge`}
                  </p>
              }
            </div>
          </>
        }
      </div>

    );
  }

});
